<nz-range-picker
  [(ngModel)]="dates"
  [required]="isRequired"
  [nzFormat]="dateFormat()"
  [nzAllowClear]="allowClear"
  [nzDisabledDate]="disableEinvDate"
  nzDropdownClassName="customCalendar"
></nz-range-picker>
